import PollingProvider from '@atlaskit/feature-gate-polling-provider/provider';
import type { ProviderOptions } from '@atlaskit/feature-gate-polling-provider/types';
import { FeatureGateEnvironment, PerimeterType } from '@atlaskit/feature-gate-js-client/types';
import { bifrostEnv } from '../config';

const isProd = bifrostEnv === 'prod';

const getFeatureGateEnv = (): FeatureGateEnvironment =>
	isProd ? FeatureGateEnvironment.Production : FeatureGateEnvironment.Staging;

const providerOptions: ProviderOptions = {
	apiKey: process.env.STATSIG_API_KEY!,
	initialFetchTimeout: 5000,
	useGatewayURL: false, // Browser extensions must use direct FFS URLs, not gateway proxy
};

/**
 * Singleton instance of PollingProvider for feature gate management
 *
 * Features:
 * - Automatic polling for feature gate updates
 * - IndexedDB caching for fast initialization
 * - Cross-tab synchronization via BroadcastChannel
 */
const provider = new PollingProvider(providerOptions);

// Using the FeatureGates client version from package.json
provider.setClientVersion('5.5.7');

export const pollingProvider: PollingProvider = provider;

export const featureGatesOptions: {
	targetApp: string;
	apiKey: string;
	environment: FeatureGateEnvironment;
	perimeter: 'commercial';
} = {
	targetApp: process.env.STATSIG_TARGET_APP!,
	apiKey: process.env.STATSIG_API_KEY!,
	environment: getFeatureGateEnv(),
	perimeter: PerimeterType.COMMERCIAL,
};
